export const BANK_TYPES = [
  { id: 'KHANBANK', name: 'Хаан банк' },
  { id: 'GOLOMT', name: 'Голомт банк' },
];
export const AMOUNT_TYPES = [
  { id: 'INCOME', name: 'Орлого' },
  { id: 'WITHDRAW', name: 'Зарлага' },
];
